"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaterialFixmethodsController = function () {
  function MaterialFixmethodsController(ProductsDataProvider, ProductPartsDataProvider, $stateParams) {
    "ngInject";

    (0, _classCallCheck3.default)(this, MaterialFixmethodsController);
    this.ProductsDataProvider = ProductsDataProvider;
    this.ProductPartsDataProvider = ProductPartsDataProvider;

    var product = ProductsDataProvider.products.findOne({ slug: $stateParams.product }),
        materials = product.materials,
        material = materials.find(function (material) {
      return material.slug == $stateParams.material;
    }),
        productFixmethods = material.spec.fixmethods,
        allFixmethods = ProductPartsDataProvider.fixmethods.find({}).map(function (fixmethod) {
      return (0, _assign2.default)({}, fixmethod);
    });

    allFixmethods.forEach(function (fixmethod) {
      fixmethod.assigned = productFixmethods.some(function (productFixmethod) {
        return fixmethod.id == productFixmethod.id;
      });
    });
    this.fixmethods = allFixmethods;
    this.product = product;
    this.material = material;
    this.filterState = "assigned";
  }

  (0, _createClass3.default)(MaterialFixmethodsController, [{
    key: "filter",
    value: function filter(fixmethods) {
      switch (this.filterState) {
        case 'assigned':
          return fixmethods.filter(function (fixmethod) {
            return fixmethod.assigned == true;
          });
        case 'unassigned':
          return fixmethods.filter(function (fixmethod) {
            return fixmethod.assigned != true;
          });
        case 'all':
          return fixmethods;
        default:
          throw new Error("unsupported filter type for fixmethods");
      }
    }
  }, {
    key: "setFilterState",
    value: function setFilterState(value, $event) {
      if ($event) {
        $event.preventDefault();
      }
      this.filterState = value;
    }
  }, {
    key: "changeShapeAssigment",
    value: function changeShapeAssigment(fixmethod, $event) {
      $event.preventDefault();
      fixmethod.__loading = true;
      var actionName = '';
      if (fixmethod.assigned) {
        actionName = 'deleteProductMaterialFixmethod';
      } else {
        actionName = 'addProductMaterialFixmethod';
      }
      this.ProductsDataProvider[actionName](this.product.id, this.material.id, fixmethod.id).then(function (responseShape) {
        delete fixmethod.__loading;
        fixmethod.assigned = !fixmethod.assigned;
      });
    }
  }]);
  return MaterialFixmethodsController;
}();

// WEBPACK FOOTER //


exports.default = MaterialFixmethodsController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-fixmethod-spec/controller.js
 **/